import { UserButton } from '@clerk/clerk-react'
import { useRouterState } from '@tanstack/react-router'
import { memo } from 'react'
import { ModeToggle } from './modeToggle'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from './ui/breadcrumb'
import { SidebarTrigger } from './ui/sidebar'

const PortfolioHeader = memo(() => {
  return (
    <div className="flex justify-between border-b px-4 py-2">
      <div className="-ml-2 flex items-center">
        <SidebarTrigger />
        <div className="mx-2 mr-4 h-6 border-r" />
        <Breadcrumb>
          <PortfolioBreadcrumbList />
        </Breadcrumb>
      </div>
      <div className="flex items-center space-x-4">
        <ModeToggle />
        <UserButton />
      </div>
    </div>
  )
})

const PortfolioBreadcrumbList = () => {
  const { location } = useRouterState()

  switch (location.pathname) {
    case '/account': {
      return (
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbPage>アカウント</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      )
    }
    case '/dashboard/export': {
      return (
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbPage className="text-muted-foreground">
              ポートフォリオ
            </BreadcrumbPage>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>データ出力</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      )
    }
    case '/dashboard': {
      return (
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbPage className="text-muted-foreground">
              ポートフォリオ
            </BreadcrumbPage>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>ダッシュボード</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      )
    }
    case '/history': {
      return (
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbPage>取引履歴</BreadcrumbPage>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>リスト表示</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      )
    }
    case '/history/summary': {
      return (
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbPage>取引履歴</BreadcrumbPage>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>サマリー表示</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      )
    }
    case '/setting': {
      return (
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbPage className="text-muted-foreground">
              設定
            </BreadcrumbPage>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>基本設定</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      )
    }
    case '/setting/action-type': {
      return (
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbPage className="text-muted-foreground">
              設定
            </BreadcrumbPage>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>取引種別の管理</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      )
    }
    case '/setting/rule': {
      return (
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbPage className="text-muted-foreground">
              設定
            </BreadcrumbPage>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>ルールの管理</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      )
    }
    case '/setting/plan': {
      return (
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbPage className="text-muted-foreground">
              設定
            </BreadcrumbPage>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>プラン＆お支払い</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      )
    }
    case '/setting/share': {
      return (
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbPage className="text-muted-foreground">
              設定
            </BreadcrumbPage>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>共有メンバーの管理</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      )
    }
    case '/setting/journal': {
      return (
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbPage className="text-muted-foreground">
              設定
            </BreadcrumbPage>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>会計仕訳</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      )
    }
    default: {
      return <></>
    }
  }
}

export default PortfolioHeader
